import React, { useState, FC, useEffect } from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import AccountCircle from "@mui/icons-material/AccountCircle";
import SearchIcon from "@mui/icons-material/Search";
import { IconButton, useTheme } from "@mui/material";
import { useRecoilState, useSetRecoilState } from "recoil";
import { userState } from "../../../../states/userState";
import { setUserToLocalStorage } from "../../../../functions/localStorageManager";
import {
  backgroundColor,
  foreColor,
  foreColorCodeLite,
  foreColorOnMouseOver,
} from "../../../../commons/colors";
import useFetchDrafts from "../../../../hooks/useFetchDrafts";
import {
  defaultProductNo,
  InvalidProductNo,
  productNoState,
} from "../../../../states/poductNoState";

const TextInputForProductNo = (props) => {
  const {
    productNo,
    setProductNo,
    productBno,
    setProductBno,
    setToggleFocus,
    setKintoneArray,
  } = props;
  const [user, setUser] = useRecoilState(userState);
  const setRecoilProductNo = useSetRecoilState(productNoState);
  const { fetchDraftsByEnterKey } = useFetchDrafts();
  // const [productNo, setProductNo] = useState(user.initialParameters.productNo);
  const theme = useTheme();

  const handleOnChange = (e) => {
    const value = e.target.value;
    const regex = /^\d{0,8}$/; // 最大8桁の数字のみを許可する正規表現

    if (regex.test(value)) {
      setToggleFocus(true);
      setProductNo(value);
    }
  };
  const handleOnFocus = (e) => {
    setRecoilProductNo(InvalidProductNo);
    setProductNo("");
    setProductBno("");
    setUser((prevUser) => {
      // const newUser: User = { ...prevUser, isAuth: true };
      // デフォルト値を設定
      // const defaultInitialParams: InitialParameters = {
      //   workersForInput: [],
      //   workersForList: [],
      //   factoryNo: [],
      //   productNo: "",
      //   productBno: "",
      //   latestUrl: "",
      // };
      const newUser = {
        ...prevUser,
        filters: {
          // ...defaultInitialParams,
          ...prevUser.filters,
          productNo: "",
        },
      };
      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  const handleOnBlur = (e) => {
    let setString =
      String(productNo).length > 0 ? String(productNo).padStart(8, "0") : "";
    setProductNo(setString);
    setUser((prevUser) => {
      const newUser = {
        ...prevUser,
        filters: {
          ...prevUser.filters,
          productNo: setString,
        },
      };
      //LocalStorageにユーザ情報をセット
      setUserToLocalStorage(newUser);
      return newUser;
    });
  };
  // useEffect(() => {
  //   setProductNo(user.initialParameters.productNo);
  // }, [user.initialParameters.productNo]);
  const handleKeyDown = async (e) => {
    if (e.key === "Enter") {
      e.target.blur();
      let setString =
        String(e.target.value).length > 0
          ? String(e.target.value).padStart(8, "0")
          : "";
      const result = await fetchDraftsByEnterKey(setString, "", "");
      setKintoneArray(result);
    }
  };
  return (
    <TextField
      // color={"#0adcc0"}
      variant="standard"
      fullWidth={props.fullWidth}
      label={props.label}
      InputLabelProps={{ shrink: true }}
      margin="dense"
      multiline={props.multiline}
      required={props.required}
      rows={props.rows}
      value={productNo}
      type={props.type}
      onChange={handleOnChange}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      onKeyDown={handleKeyDown}
      disabled={props.disabled}
      placeholder={props.placeholder}
      InputProps={{
        ...props.InputProps,
        endAdornment: props.InputProps ? (
          // <InputAdornment position="start">
          //   <div
          //     style={{
          //       backgroundColor: "#0adcc0",
          //       width: "36px",
          //       height: "20px",
          //       paddingLeft: "6px",
          //       borderRadius: "5px",
          //       cursor: "pointer",
          //     }}
          //     onClick={props.onClick}
          //   >
          //     <SearchIcon />
          //   </div>
          // </InputAdornment>
          <></>
        ) : null,
        sx: {
          "& .MuiInput-underline:before": {
            borderBottomColor: foreColorCodeLite(user?.mode ?? "lite"), // 通常時の下線の色
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: foreColorCodeLite(user?.mode ?? "lite"), // フォーカス時の下線の色
          },
          "& .MuiInput-underline:hover:before": {
            borderBottomColor: `${foreColorCodeLite(
              user?.mode ?? "lite"
            )}!important`, // ホバー時の下線の色
          },
          "& .MuiInput-underline": {
            borderBottomColor: `${foreColorCodeLite(
              user?.mode ?? "lite"
            )}!important`, // ホバー時の下線の色
          },
          // 他のスタイルもここに追加できます
          fontFamily: '"Noto Sans", sans-serif',
        },
      }}
      sx={{
        margin: "20px 0",

        "&&&": {
          // color: "blue",
          width: "95px",
          height: "42px",
          backgroundColor: backgroundColor(user?.mode ?? "lite"),
          padding: "5px 10px 2px 10px",
          borderRadius: "5px",
        },
        "& label": {
          padding: "10px",
          color: foreColorCodeLite(user?.mode ?? "lite"),
          fontSize: "18px",
        },
        "& svg": {
          // marginTop: "5px",
          color: "#f0f2f5",
        },
        "& input": {
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: "5px",
          paddingLeft: "2px",
          fontSize: "16px",
          color: foreColorCodeLite(user?.mode ?? "lite"),
          fontWeight: "700",
          "&:hover": {
            color: foreColorCodeLite(user?.mode ?? "lite"),
          },
          "&:focus": {
            color: foreColorCodeLite(user?.mode ?? "lite"),
          },
          //   backgroundColor: "black",
        },
        "& .MuiSvgIcon-root": {
          color: "#f0f2f5",
        },
        "& .MuiInputBase-input": {
          fontSize: "16px",
          color: foreColorCodeLite(user?.mode ?? "lite"),
          fontWeight: "700",
        },
        // InputPropsで指定したスタイル以外にもここで追加できます
      }}
    />
  );
};
export default TextInputForProductNo;
